import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeaderSearch from './HeaderSearch';
import { SubscribeRibbon } from './SubscribeRibbon';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import PersonDetail from './PersonDetail';
import {Helmet} from "react-helmet";

function PageNotFound() {

  return (
    <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Page Not Found | Blessingsonthenet.com</title>
    </Helmet> 
    <div>

      <section class="py-10 d-flex items-center bg-light-2 mt-20">
        <div class="container">
          <div class="row y-gap-10 items-center justify-between">
            <div class="col-auto">
              <div class="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                <div class="col-auto">
                  <div class="">Home</div>
                </div>
                <div class="col-auto">
                  <div class="">&gt;</div>
                </div>
                <div class="col-auto">
                  <div class="text-dark-1">Page Not Found</div>
                </div>
              </div>
            </div>

            <div class="col-auto">
              {/*<a href="#" class="text-14 text-blue-1 underline">View Commons Involving Dwarka</a>*/}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="relative container">
            <div class="row mt-30 mb-50">
                <div class="col-sm-12 col-xl-12 col-lg-12">
                    <div class="px-40 pt-40 pb-50 lg:px-30 lg:py-30 md:px-24 md:py-24 bg-white rounded-4 shadow-4 mt-20 mb-20">
                        <center>
                            <h1>404</h1>
                            <div class="text-22 fw-500">
                                Oops, This Page Was Not Found!<br />
                                <a href="/">Return to Homepage</a>
                            </div>
                        </center>
                    </div>
                </div>
            </div>
        </div>
    </section>

      <SubscribeRibbon />
    </div>
    </>
  );
}

export default PageNotFound;
